import io from 'socket.io-client';
import Const from 'constants';
import Action from 'actions';

const socket = io(__preSettings__.nodeUrl, {
    path: __preSettings__.nodePath,
    // transports: ['websocket']
});

socket.on('connect_error', (error) => {
    console.error('SOCKET_CONNECT_ERR: ', error);
});
socket.on('error', (error) => {
    console.error('SOCKET_ERR: ', error);
});
socket.on('disconnect', (reason) => {
    console.error('SOCKET_DISCONNECT: ', reason);
});
socket.on('connect_timeout', (timeout) => {
    console.log('SOCKET_CONNECT_TIMEOUT: ', timeout);
});
socket.on('connect', () => {
    console.log('SOCKET_CONNECT');
});

export default socket;

export function runSocketListener(store) {
    socket
        .on(Const.SOCKET_ON_SET_SLATE, (data) => {
            return store.dispatch(Action.do('socketSetSlate', data));
        })
        .on(Const.SOCKET_ON_SET_GAMES, (data) => {
            return store.dispatch(Action.do('socketSetGames', data));
        })
        .on(Const.SOCKET_ON_SET_PLAYERS, (data) => {
            return store.dispatch(Action.do('socketSetPlayers', data));
        })
        .on(Const.SOCKET_ON_UPDATE_PLAYERS, (data) => {
            return store.dispatch(Action.do('socketUpdatePlayers', data));
        })
        .on(Const.SOCKET_ON_DELETE_PLAYERS, (data) => {
            return store.dispatch(Action.do('socketDeletePlayers', data));
        });
}
